import React, { FC } from 'react';
import QRCode from 'react-qr-code';

// Components
import { ErrorMessage } from '../ErrorMessage';

// i18n
import { useTranslation } from '../../translations/useTranslation';

// Interfaces
import { CgiPollingStatus } from '../../interfaces/CGI';

// Context
import { useForm } from '../../context/form-context/hooks';

// Utils
import { getProviderNameFromProvider } from '../../utilities/utils';

interface Props {
  qrCodeDate?: string;
  pollingStatus: CgiPollingStatus;
  pollingError?: string;
}

export const CgiAnotherDevice: FC<Props> = ({
  qrCodeDate,
  pollingStatus,
  pollingError,
}) => {
  const { state } = useForm();
  const { t, m, keys } = useTranslation();
  return (
    <div>
      {pollingStatus !== CgiPollingStatus.ERROR && (
        <p>
          {m(keys.cgidAnotherStep1, '{provider}', getProviderNameFromProvider(state.provider) || '')} <br />
          {t(keys.cgidAnotherStep2)} <br />
          {t(keys.cgidAnotherStep3)} <br />
        </p>
      )}
{}
      {qrCodeDate && <QRCode value={qrCodeDate} size={200} />}
      <div className="membership-app__view-polling-state">
        <div>
          {pollingStatus === CgiPollingStatus.APP_OPEN && (
            <span>{m(keys.cgiSignInProgress, '{provider}', getProviderNameFromProvider(state.provider) || '')}</span>
          )}
          {(pollingStatus === CgiPollingStatus.ERROR ||
            pollingStatus === CgiPollingStatus.CANCELED) &&
            pollingError && <ErrorMessage message={pollingError} />}
        </div>
        {pollingStatus === CgiPollingStatus.APP_OPEN && (
          <div className="circle-loader circle-loader--v1" role="alert">
            <div aria-hidden="true">
              <div className="circle-loader__circle"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
